import * as z from "zod";

export const generateCommerceCloudImportFiles = {
  name: "generateCommerceCloudImportFiles" as const,
  input: z.object({
    productId: z.string().min(1),
    catalogId: z.string().min(1),
    currency: z.string().length(3),
    pricebookId: z.string().min(1),
    inventoryListId: z.string().min(1).nullish(),
  }),
  output: z.object({
    files: z.array(z.object({ name: z.string(), content: z.string() })),
  }),
};
